<template>
  <section class="privacy-policy">
    <p class="privacy-policy__mainText">
      {{ data.description }}
    </p>
    <div v-for="(item,index) in data.policies" :key="index" class="privacy-policy__wrapper">
      <h2 class="privacy-policy__title">
        {{ item.title }}
      </h2>
      <p class="privacy-policy__mainText">
        {{ item.policy }}
      </p>
      <div>
        <ul v-for="(bullet,bulletIndex) in item.bullets" :key="bulletIndex" class="mb-4 lg:mb-6 last:mb-0">
          <li class="privacy-policy__bulletTitle">
            {{ bullet.title }}
          </li>
          <li class="privacy-policy__mainText">
            {{ bullet.content }}
          </li>
        </ul>
      </div>
      <div class="mt-4  ">
        <p v-for="(importantText,importantIndex) in item.important" :key="importantIndex" class="privacy-policy__importantText">
          {{ importantText }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import staticData from './static-data'
export default {
  name: 'PrivacyPolicyContent',
  data () {
    return {
      data: staticData
    }
  }
}
</script>

<style scoped lang="scss">
.privacy-policy{
  @apply container;
  &__wrapper{
    @apply mt-8 lg:mt-14;
  }
  &__title{
    @apply p-2 bg-primary-50 rounded-lg w-fit text-primary-700
    text__headline-4-xs--bold lg:text__headline-5-md--bold mb-4 mb-6;
  }
  &__mainText{
  @apply text__body-2-xs--regular text-body-1 lg:text__body-1-md--regular
 }
  &__bulletTitle{
  @apply text__body-1-xs--bold text-body-1 lg:text__body-1-md--bold list-disc list-inside mb-2;
 }
  &__importantText{
  @apply text__body-2-xs--bold text-title lg:text__body-1-md--bold mb-2 last:mb-0;
 }
}
</style>
